/* eslint-disable */
import React, { FC } from 'react';
import './label.scss';

interface ILabelProps {
  text: string | any;
  className?: string;
  style?: {};
}

const Label: FC<ILabelProps> = ({ text, className, style }) => {
  return (
    <div style={style} className={`text-wrapper ${className}`}>
      {text}
    </div>
  );
};

export default Label;
